jQuery(document).ready(function($) {
  $(".featured-blog__carousel").owlCarousel({
    loop: false,
    dots: false,
    nav: false,
    dotsSpeed: 800,
    margin: 15,
    mouseDrag: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
        margin: 0
      },
      578: {
        items: 2
      },
      991: {
        items: 3
      }
    }
  });

  //Scrool header bar
  function fixedHeader() {
    var height = $(window).scrollTop(); //getting the scrolling height of window
    if (height > 70) {
      $(".main-header").addClass("navbar-faded");
    } else {
      $(".main-header").removeClass("navbar-faded");
    }
  }

  fixedHeader();

  if ($(".main-header").length) {
    $(window).on("scroll", function() {
      // this will work when your window scrolled.
      fixedHeader();
    });
  }

  var $carouselclientes = $(".customer-sucess__list");

  $carouselclientes.owlCarousel({
    dots: true,
    nav: false,
    loop: true,
    margin: 15,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    smartSpeed: 800,
    dotsSpeed: 800,
    responsive: {
      0: {
        items: 2
      },
      768: {
        items: 3
      },
      992: {
        items: 6
      }
    }
  });

  $(".select-category").change(function() {
    var link = $(this)
      .find(":selected")
      .data("link");
    window.location.href = link;
  });

  /*
   *
   * FAQ
   *
   * */

  $(".accordion > li:eq(0) .link-drop")
    .addClass("active")
    .next()
    .slideDown();

  $(".accordion .link-drop").click(function(j) {
    var dropDown = $(this)
      .closest("li")
      .find(".conteudo-acordion");

    $(this)
      .closest(".accordion")
      .find(".conteudo-acordion")
      .not(dropDown)
      .slideUp();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this)
        .closest(".accordion")
        .find(".link-drop.active")
        .removeClass("active");
      $(this).addClass("active");
    }

    dropDown.stop(false, true).slideToggle();

    j.preventDefault();
  });

  /*MENU RESPONSIVO*/

  $(".menu-mobile").click(function(event) {
    event.preventDefault();
    $(".menu-mobile").toggleClass("active");
    var menuresponsivo = $(".menu-mobile-open");
    if ($(menuresponsivo).is(":hidden ")) {
      menuresponsivo.slideDown(200);
    } else {
      menuresponsivo.slideUp(200);
    }
  });
});

jQuery(document).ready(function($) {
  var $window = $(window);
  // Scroll up
  var $scrollup = $(".btn-scrool");

  $scrollup.on("click", function(evt) {
    $("html, body").animate({ scrollTop: 0 }, 600);
    evt.preventDefault();
  });
});
